export const isActionValid = (validActions: string[] | { [key: string]: string }) => (
  name: string | undefined,
) => {
  if (!name) {
    return false;
  }

  if (Array.isArray(validActions)) {
    return validActions.includes(name);
  }

  return !!validActions[name];
};
